const services = {
  cars: 'Cars',
  addCar: 'Add Car',
  editCar: 'Edit Car',
};
export default services;
